// EDEN · session state (the signed-in user, role-aware).

import { api } from "./api";

export interface Me {
  id: string;
  name: string;
  auth_role: "teacher" | "lead";
}

let current: Me | null = null;

export const me = (): Me | null => current;
export const setMe = (m: Me | null): void => {
  current = m;
};

/** Re-resolve the user from the session cookie (null if signed out). */
export async function refreshMe(): Promise<Me | null> {
  try {
    current = await api<Me>("/api/me");
  } catch {
    current = null;
  }
  return current;
}
